import { useTranslation } from 'react-i18next';

import {
  companiesFilterOptionsState,
  selectedCompaniesFiltersState,
} from '@/features/companies/companies.state';
import { isNumberOptionArray } from '@/helpers/other';
import { AsyncSelect } from '@/ui/select/async/async-select';
import { sharedProps } from '@/ui/select/select-shared';
import { useAtom, useAtomValue } from 'jotai';

export const RankingFilter = ({ className }: { className?: string }) => {
  const { t } = useTranslation('companies');

  const [selectedFilters, setSelectedFilters] = useAtom(
    selectedCompaniesFiltersState,
  );

  const filterOptions = useAtomValue(companiesFilterOptionsState);

  return (
    <AsyncSelect
      id="filter-ranking"
      label={t`companies.filters.ranking`}
      defaultValue={selectedFilters.ranking}
      setOptions={filterOptions.ranking}
      isSearchable={false}
      isMulti
      className={className}
      onChange={option => {
        if (!isNumberOptionArray(option)) return;

        setSelectedFilters(currentFilters => {
          return {
            ...currentFilters,
            ranking: option.length ? option : null,
          };
        });
      }}
      {...sharedProps}
    />
  );
};
